import React, { Suspense, useContext, useEffect } from "react";

import { Navigate, useLocation } from "react-router";
import Navigation from "../Layouts/Navigation";
import { AuthContext } from "../Context/AuthContext";
import { hasAffiliate, publicRoutesName } from "../Utils/utils";
import RoundLoaderWithOverlay from "../Components/Common/Loader/RoundLoader";

const PublicRoutes = ({ component: RouteComponent, ...rest }) => {
  const { userData } = useContext(AuthContext);
  const { pathname } = useLocation();
  const isAuthenticating = userData?.isFetching;

  useEffect(() => {
    //const  meta = document.createElement("meta");
    var meta = document.getElementById("metaDescription");

    if (pathname === "/sign-in") {
      document.title = "Saleoid Login";
      meta.name = "description";
      meta.content = "Sign in to your Saleoid account";
    } else if (pathname === "/signup") {
      document.title = "Sign up with Saleoid";
      meta.name = "description";
      meta.content = "Sign up to create your Saleoid account";
    } else if (pathname === "/verify-email") {
      document.title = "Verify Email";
      meta.name = "description";
      meta.content = "Verify Email";
    } else {
      document.title = "Saleoid";
      meta.name = "description";
      meta.content = "Saleoid";
    }
    //document.getElementsByTagName("head")[0].appendChild(meta);
  }, [pathname]);

  const executePublicRoute = (rest) => {
    if (isAuthenticating) {
      return <RoundLoaderWithOverlay />;
    }

    const isExplicitPublicRoute =
      publicRoutesName.filter(
        (item) => item !== "/signup" && pathname.includes(item)
      ).length > 0;

    if (isExplicitPublicRoute) {
      return <RouteComponent />;
    } else if (userData.authenticated) {
      if (hasAffiliate(userData)) {
        return <Navigate to="/dashboard" />;
      } else if (
        publicRoutesName.filter((item) => pathname.includes(item)).length === 0
      ) {
        return (
          <Navigate
            to="/choose-company"
            state={{
              landingUrl:
                rest.location &&
                rest.location.state &&
                rest.location.state.landingUrl
                  ? rest.location.state.landingUrl
                  : "/dashboard",
            }}
          />
        );
      } else if (pathname !== "/signup" || pathname !== "verify-email") {
        return <Navigate to="/dashboard" />;
      } else {
        return <RouteComponent />;
      }
    }

    if (!userData?.authenticated) {
      return <RouteComponent />;
    }

    return <RouteComponent />;
  };

  /*******/
  return (
    <>
      {rest.hasNavigation && <Navigation />}
      <Suspense fallback={<RoundLoaderWithOverlay />}>
        {executePublicRoute(rest)}
      </Suspense>
    </>
  );
};
export default PublicRoutes;
